import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

Component.registerHooks(['beforeRouteLeave']);

@Component({})
export default class CompleteStep extends Vue {
  public beforeRouteLeave(_to: Route, _from: Route, next: () => void) {
    this.$store.dispatch('app/completeStep', this.$route.name || '');

    next();
  }
}
